import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <div className="relative min-h-screen flex flex-col">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: 'url(https://static.readdy.ai/image/39cbf484d561e1f62e3c6532cd56d730/df0dfdeca5fded0a444b18858182fb9b.png)'
        }}
      ></div>
      <div className="absolute inset-0 bg-black/70"></div>

      <nav className="relative z-10 transition-all duration-300" id="main-nav">
        <div className="max-w-[1400px] mx-auto px-5 md:px-8 py-5 md:py-6 flex items-center justify-between">
          <h1 className="flex items-center cursor-pointer">
            <img
              src="https://static.readdy.ai/image/39cbf484d561e1f62e3c6532cd56d730/5b0e55db21655eca8e03e44a17fcce4c.png"
              alt="EasyMarketPro - AI Customer Support Agents"
              className="h-10 md:h-14 w-auto"
            />
            <span className="ml-2 text-[18px] md:text-[22px] font-bold text-[#B8985F] tracking-tight">EasyMarketPro</span>
          </h1>
          <div className="flex items-center gap-4 md:gap-6">
            <a
              href="#how-it-works"
              className="hidden sm:block text-[14px] text-white/90 hover:text-white transition-colors cursor-pointer font-medium whitespace-nowrap"
            >
              How It Works
            </a>
            <a
              href="#use-cases"
              className="hidden sm:block text-[14px] text-white/90 hover:text-white transition-colors cursor-pointer font-medium whitespace-nowrap"
            >
              Use Cases
            </a>
            <Link
              to="/about"
              className="hidden sm:block text-[14px] text-white/90 hover:text-white transition-colors cursor-pointer font-medium whitespace-nowrap"
            >
              About
            </Link>
            <Link
              to="/book-a-call"
              className="px-5 py-2.5 bg-[#B8985F] hover:bg-[#A68850] text-white text-[14px] font-semibold rounded-lg transition-all cursor-pointer whitespace-nowrap"
            >
              Book a Call
            </Link>
          </div>
        </div>
      </nav>

      <div className="relative z-10 max-w-[1200px] mx-auto px-5 md:px-8 w-full pt-40 md:pt-44 pb-16">
        <div className="flex flex-col lg:flex-row items-center justify-between gap-10 lg:gap-16">
          <div className="max-w-[640px]">
            <div className="inline-flex items-center gap-2 px-3 md:px-4 py-1.5 md:py-2 rounded-full border border-[#B8985F]/40 bg-[#B8985F]/10 mb-6 md:mb-8">
              <div className="w-2 h-2 rounded-full bg-[#B8985F] animate-pulse"></div>
              <span className="text-[11px] md:text-[13px] text-[#B8985F] font-medium tracking-wide">AI-Powered Support Automation</span>
            </div>

            <h1 className="text-[36px] sm:text-[42px] md:text-[48px] lg:text-[54px] font-bold text-white leading-[1.1] mb-5 md:mb-7">
              Reduce ticket volume and support cost without increasing headcount.
            </h1>

            <p className="text-[18px] md:text-[22px] lg:text-[26px] text-[#C8C8C8] leading-[1.6] mb-8 md:mb-10">
              AI customer support agents built for real support operations.
            </p>

            <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3 sm:gap-5">
              <Link
                to="/book-a-call"
                className="px-8 md:px-10 py-3.5 md:py-4 bg-[#B8985F] text-black text-[14px] md:text-[15px] font-semibold rounded-md hover:bg-[#A68850] transition-all cursor-pointer whitespace-nowrap text-center"
              >
                Book a Call
              </Link>
              <a
                href="#how-it-works"
                className="px-8 md:px-10 py-3.5 md:py-4 border border-white/30 text-white text-[14px] md:text-[15px] font-medium rounded-md hover:border-[#B8985F] hover:text-[#B8985F] transition-all cursor-pointer whitespace-nowrap flex items-center justify-center gap-2"
              >
                How It Works
                <i className="ri-arrow-down-s-line w-5 h-5 flex items-center justify-center"></i>
              </a>
            </div>
          </div>

          <div className="flex-shrink-0 hidden lg:block">
            <div className="relative w-[440px] h-[360px]">
              <div className="absolute top-0 right-0 w-[380px] bg-[#141414]/80 backdrop-blur-md rounded-lg border border-[#B8985F]/20 p-5 shadow-[0_20px_60px_rgba(0,0,0,0.5)]">
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-3 h-3 rounded-full bg-[#B8985F]"></div>
                  <span className="text-[13px] text-[#B8985F] font-medium">AI Agent Active</span>
                  <span className="ml-auto text-[11px] text-[#888]">Live</span>
                </div>
                <div className="space-y-3">
                  <div className="flex items-center gap-3 bg-[#1A1A1A] rounded-md p-3">
                    <div className="w-8 h-8 rounded-full bg-[#B8985F]/20 flex items-center justify-center flex-shrink-0">
                      <i className="ri-customer-service-2-line text-[#B8985F] text-sm w-4 h-4 flex items-center justify-center"></i>
                    </div>
                    <div className="flex-1 min-w-0">
                      <p className="text-[12px] text-[#999]">Billing inquiry resolved</p>
                      <p className="text-[11px] text-[#666]">Response time: 4s</p>
                    </div>
                    <span className="text-[11px] text-emerald-400 whitespace-nowrap">Resolved</span>
                  </div>
                  <div className="flex items-center gap-3 bg-[#1A1A1A] rounded-md p-3">
                    <div className="w-8 h-8 rounded-full bg-[#B8985F]/20 flex items-center justify-center flex-shrink-0">
                      <i className="ri-shield-keyhole-line text-[#B8985F] text-sm w-4 h-4 flex items-center justify-center"></i>
                    </div>
                    <div className="flex-1 min-w-0">
                      <p className="text-[12px] text-[#999]">Password reset completed</p>
                      <p className="text-[11px] text-[#666]">Response time: 2s</p>
                    </div>
                    <span className="text-[11px] text-emerald-400 whitespace-nowrap">Resolved</span>
                  </div>
                  <div className="flex items-center gap-3 bg-[#1A1A1A] rounded-md p-3">
                    <div className="w-8 h-8 rounded-full bg-amber-500/20 flex items-center justify-center flex-shrink-0">
                      <i className="ri-user-voice-line text-amber-400 text-sm w-4 h-4 flex items-center justify-center"></i>
                    </div>
                    <div className="flex-1 min-w-0">
                      <p className="text-[12px] text-[#999]">Complex case escalated</p>
                      <p className="text-[11px] text-[#666]">Routed to Tier 2</p>
                    </div>
                    <span className="text-[11px] text-amber-400 whitespace-nowrap">Escalated</span>
                  </div>
                </div>
              </div>

              <div className="absolute bottom-0 left-0 w-[220px] bg-[#141414]/80 backdrop-blur-md rounded-lg border border-[#B8985F]/20 p-4 shadow-[0_20px_60px_rgba(0,0,0,0.5)]">
                <p className="text-[11px] text-[#888] mb-2">Today&apos;s Performance</p>
                <div className="flex items-end gap-1 mb-2">
                  {[40, 55, 35, 65, 50, 70, 60, 75, 45, 80, 55, 72].map((h, i) => (
                    <div
                      key={i}
                      className="flex-1 rounded-sm"
                      style={{
                        height: `${h * 0.5}px`,
                        backgroundColor: i >= 9 ? '#B8985F' : '#2A2A2A'
                      }}
                    ></div>
                  ))}
                </div>
                <div className="flex items-center justify-between">
                  <span className="text-[18px] font-bold text-white">847</span>
                  <span className="text-[11px] text-emerald-400">tickets resolved</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
